import { render } from "./clinics.vue?vue&type=template&id=61317df4"
import script from "./clinics.vue?vue&type=script&lang=js"
export * from "./clinics.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/mixitweb-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__